import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '../assets/icons/icon_menu.svg'
import _imports_1 from '../assets/icons/close_icon.svg'
import _imports_2 from '../assets/icons/icon_enter.svg'


const _hoisted_1 = { class: "<sm:hidden horiz-center px-185px <xl:px-85px <lg:px-40px pb-100px" }
const _hoisted_2 = { class: "text-48px <xl:text-34px font-500 transform-gpu -translate-y-15px <xl:-translate-y-5px uppercase" }
const _hoisted_3 = { class: "text-24px <xl:text-18px uppercase" }
const _hoisted_4 = { href: "https://rko-group.ru/auth/" }
const _hoisted_5 = { class: "sm:hidden mb-35px" }
const _hoisted_6 = { class: "px-50px horiz-center mt-20px mb-60px justify-between" }
const _hoisted_7 = { class: "hover:opacity-60" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "fill-black h-20px w-20px",
  src: _imports_0
}
const _hoisted_10 = {
  key: 1,
  class: "fill-black h-18px w-20px",
  src: _imports_1
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "fill-white h-20px w-20px",
  src: _imports_0
}
const _hoisted_13 = {
  key: 1,
  class: "fill-white h-20px w-20px",
  src: _imports_1
}
const _hoisted_14 = { href: "https://rko-group.ru/auth/" }
const _hoisted_15 = { class: "hover:opacity-60" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  class: "fill-black h-20px w-20px",
  src: _imports_2
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  class: "fill-white h-20px w-20px",
  src: _imports_2
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo = _resolveComponent("logo")!
  const _component_login_button = _resolveComponent("login-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_svg_inline = _resolveDirective("svg-inline")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_logo, {
        white: _ctx.white,
        class: _normalizeClass(["ml-19px", { 'opacity-0': _ctx.hide_logo }])
      }, null, 8, ["white", "class"]),
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-col ml-136px <xl:ml-90px", { 'text-white': _ctx.white }])
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1),
        _createElementVNode("span", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 2),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "spacer" }, null, -1)),
      _createElementVNode("a", _hoisted_4, [
        (!_ctx.hide_enter_button)
          ? (_openBlock(), _createBlock(_component_login_button, {
              key: 0,
              white: _ctx.white
            }, null, 8, ["white"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: _ctx.close ? '/' : '/menu'
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", _hoisted_7, [
              (!_ctx.white)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (!_ctx.close)
                      ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_9, null, 512)), [
                          [_directive_svg_inline]
                        ])
                      : _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_10, null, 512)), [
                          [_directive_svg_inline]
                        ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (!_ctx.close)
                      ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_12, null, 512)), [
                          [_directive_svg_inline]
                        ])
                      : _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_13, null, 512)), [
                          [_directive_svg_inline]
                        ])
                  ]))
            ])
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_logo, {
          white: _ctx.white,
          class: _normalizeClass({ 'opacity-0': _ctx.hide_logo })
        }, null, 8, ["white", "class"]),
        _createElementVNode("a", _hoisted_14, [
          _createElementVNode("button", _hoisted_15, [
            (!_ctx.white)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("img", _hoisted_17, null, 512), [
                    [_directive_svg_inline]
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("img", _hoisted_19, null, 512), [
                    [_directive_svg_inline]
                  ])
                ]))
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([{ 'text-black': !_ctx.white }, "px-50px text-18px uppercase text-white mb-5px font-500"])
      }, _toDisplayString(_ctx.title), 3),
      _createElementVNode("div", {
        class: _normalizeClass([{ 'text-black': !_ctx.white }, "px-50px text-14px uppercase text-white"])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ])
  ]))
}